module.exports = __webpack_public_path__ + "img/oie-usp-01.png";